import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalUserAnswersQuestionsPage } from './modal-user-answers-questions.page';

const routes: Routes = [
  {
    path: '',
    component: ModalUserAnswersQuestionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalUserAnswersQuestionsPageRoutingModule {}
